<template>
  <div
    class="custom-box-shadow flex h-full w-auto flex-col rounded border border-light-gray p-4"
  >
    <div class="mr-8 flex flex-row justify-between">
      <h1 class="mr-4 text-lg font-medium">
        {{ nullTextify(insurance.insurance_type) }}
      </h1>
      <custom-badge
        text="Active"
        size="md"
        bgColorClass="bg-green-500"
        colorClass="text-white"
      ></custom-badge>
    </div>
    <div class="my-3 flex flex-col">
      <span class="mb-1 text-xs font-bold text-gray-400">INSURER NAME</span>
      <p class="text-base font-medium text-gray-600">
        {{ nullTextify(insurance.insurer_name) }}
      </p>
    </div>
    <div class="my-3 flex justify-start gap-6">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col">
          <span class="mb-1 text-xs font-bold text-gray-400">POLICY #</span>
          <span class="text-base font-medium text-gray-600">{{
            formatPolicy(insurance.policy_number)
          }}</span>
        </div>
        <div class="flex flex-col">
          <span class="mb-1 text-xs font-bold text-gray-400"
            >EFFECTIVE DATE</span
          >
          <span class="text-base font-medium text-gray-600">{{
            nullTextify(displayDate(insurance.effective_date))
          }}</span>
        </div>
      </div>
      <div class="flex flex-col gap-6">
        <div class="flex flex-col">
          <span class="mb-1 text-xs font-bold text-gray-400">COVERAGE</span>
          <span class="text-base font-medium text-gray-600"
            >${{ nullTextify(coverageInThousands.toLocaleString()) }}</span
          >
        </div>
        <div class="flex flex-col">
          <span class="mb-1 text-xs font-bold text-gray-400"
            >CANCELLATION DATE</span
          >
          <span class="text-base font-medium text-gray-600">
            {{ nullTextify(displayDate(insurance.cancellation_date)) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomBadge from './CustomBadge.vue';
import moment from 'moment';

export default {
  components: { CustomBadge },
  name: 'InsuranceGovernmentCard',
  props: {
    insurance: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coverageInThousands() {
      return this.insurance.coverage * 1000;
    },
  },
  methods: {
    displayDate: function (initialDate) {
      if (initialDate == null) {
        return initialDate;
      } else {
        return moment(initialDate, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    nullTextify: function (value, nullVal = 'N/A') {
      if (value == null) {
        return nullVal;
      } else {
        return value;
      }
    },
    formatPolicy(number) {
      const policy = this.nullTextify(number);

      if (policy?.length > 30) {
        return `${policy.slice(0, 28)}...`;
      }

      return policy;
    },
  },
};
</script>
